import { lazy, Suspense, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// Layout components
import Navbar from "./components/layout/navbar/Navbar";
import RootLevelFooter from "./components/layout/footers/root-level/RootLevelFooter";
import GlobalSuspense from "./components/layout/suspense/Global";
// Root-level pages
const Home = lazy(() => import("./pages/root-level/Home"));
const Markets = lazy(() => import("./pages/root-level/Markets"));
const TermsAndConditions = lazy(() =>
  import("./pages/root-level/TermsAndConditions")
);
const Guide = lazy(() => import("./pages/root-level/Guide"));
const Commissions = lazy(() => import("./pages/root-level/Commissions"));
const AboutUs = lazy(() => import("./pages/root-level/AboutUs"));
const ContactUs = lazy(() => import("./pages/root-level/ContactUs"));
// Auth pages
const Auth = lazy(() => import("./pages/auth/Auth"));
const Login = lazy(() => import("./pages/auth/login/Login"));
const Signup = lazy(() => import("./pages/auth/signup/Signup"));
const OTP = lazy(() => import("./pages/auth/otp/OTP"));
const ForgotPassword = lazy(() =>
  import("./pages/auth/forgot-password/ForgotPassword")
);
const SetNewPassword = lazy(() =>
  import("./pages/auth/set-new-password/SetNewPassword")
);
// Panel pages
const Panel = lazy(() => import("./pages/panel/Panel"));
const Dashboard = lazy(() => import("./pages/panel/dashboard/Dashboard"));
const Authentication = lazy(() =>
  import("./pages/panel/authentication/Authentication")
);
const Exchange = lazy(() => import("./pages/panel/exchange/Exchange"));
const P2P = lazy(() => import("./pages/panel/p2p/P2P"));
const Assets = lazy(() => import("./pages/panel/assets/Assets"));
const History = lazy(() => import("./pages/panel/history/History"));
const InviteFriends = lazy(() =>
  import("./pages/panel/invite-friends/InviteFriends")
);
const Support = lazy(() => import("./pages/panel/support/Support"));
const Notifications = lazy(() =>
  import("./pages/panel/notifications/Notifications")
);
const Settings = lazy(() => import("./pages/panel/settings/Settings"));

const App = () => {
  // Hooks
  const { pathname } = useLocation();
  // Conditions
  const renderRootLevelFooter =
    !pathname.startsWith("/panel") &&
    !pathname.startsWith("/auth") &&
    !pathname.startsWith("/markets");
  // Functions
  // // Scroll to top on path change
  useEffect(() => {
    window.scroll({ top: 0, behavior: "smooth" });
  }, [pathname]);

  return (
    <div>
      <Navbar />

      <Suspense fallback={<GlobalSuspense />}>
        <Routes>
          {/* Root-level */}
          <Route path={"/"} element={<Home />} />
          <Route path={"/markets/:product"} element={<Markets />} />
          <Route
            path={"/terms-and-conditions"}
            element={<TermsAndConditions />}
          />
          <Route path={"/guide"} element={<Guide />} />
          <Route path={"/commissions"} element={<Commissions />} />
          <Route path={"/about-us"} element={<AboutUs />} />
          <Route path={"/contact-us"} element={<ContactUs />} />
          {/* Auth */}
          <Route path={"/auth/*"} element={<Auth />}>
            <Route path={"login"} element={<Login />} />
            <Route path={"signup"} element={<Signup />} />
            <Route path={"otp"} element={<OTP />} />
            <Route path={"forgot-password"} element={<ForgotPassword />} />
            <Route path={"set-new-password"} element={<SetNewPassword />} />
          </Route>
          {/* Panel */}
          <Route path={"/panel/*"} element={<Panel />}>
            <Route path={"dashboard"} element={<Dashboard />} />
            <Route path={"authentication"} element={<Authentication />} />
            <Route path={"exchange"} element={<Exchange />} />
            <Route path={"p2p"} element={<P2P />} />
            <Route path={"assets"} element={<Assets />} />
            <Route path={"history"} element={<History />} />
            <Route path={"invite-friends"} element={<InviteFriends />} />
            <Route path={"support"} element={<Support />} />
            <Route path={"notifications"} element={<Notifications />} />
            <Route path={"settings"} element={<Settings />} />
          </Route>
        </Routes>
      </Suspense>

      {renderRootLevelFooter && <RootLevelFooter />}

      <ToastContainer position={"top-left"} rtl />
    </div>
  );
};

export default App;
